var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.6308e-07 6.99999C-2.39351e-07 7.54285 0.44 7.98285 0.982857 7.98285L19.9086 7.98285L16.5486 11.3429C16.1657 11.7257 16.1657 12.3486 16.5486 12.7314C16.9314 13.1143 17.5543 13.1143 17.9371 12.7314L22.9714 7.69714C23.16 7.50857 23.2571 7.25714 23.2571 7.00571C23.2571 6.75428 23.16 6.50285 22.9714 6.31428L17.9371 1.27999C17.5543 0.897129 16.9314 0.897129 16.5486 1.27999C16.1657 1.66284 16.1657 2.2857 16.5486 2.66856L19.9086 6.02856L0.977143 6.02856C0.434285 6.02285 -2.8681e-07 6.45714 -2.6308e-07 6.99999Z",
    fill: "#3C3F43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.220eefa7d61859d1b76d6461fc24e8a1.svg";
export { ForwardRef as ReactComponent };